module.exports = __webpack_public_path__ + "img/Group 4.24f883e0.png";